export default {
      id: "lely-bg-arrow-dsktp-usage",
      viewBox: "0 0 1076 900",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#lely-bg-arrow-dsktp",
      toString: function () {
        return this.url;
      }
    }